import axios from "axios";
import Configuration from "../environment";

const fetchControllersNumber = async (startDate, endDate) => {
  return axios.get(
    Configuration.backend_api_url +
      `/analytics/active-controller?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`,
    {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    }
  );
};

const fetchTotalUpTime = async (startDate, endDate) => {
  return axios.get(
    Configuration.backend_api_url +
      `/analytics/total-uptime?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`,
    {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    }
  );
};

const fetchActiveUsers = async (startDate, endDate) => {
  return axios.get(
    Configuration.backend_api_url +
      `/analytics/active-users?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`,
    {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    }
  );
};

const countActivePosBetweenDates = async (startDate, endDate) => {
    return axios.get(
        Configuration.backend_api_url +
          `/analytics/count-pos?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`,
        {
          headers: {
            Authorization: localStorage.getItem("token"),
          },
        }
      );
}

const refreshDashboard = async (startDate, endDate) => {
  const controllerNumberResponse = await fetchControllersNumber(
    startDate,
    endDate
  );
  const totalUpTimeResponse = await fetchTotalUpTime(startDate, endDate);
  const activeUsersResponse = await fetchActiveUsers(startDate, endDate);
  const countActivePosBetweenDatesResponse = await countActivePosBetweenDates(startDate, endDate);
  return Promise.resolve({
    controllerNumber: controllerNumberResponse.data,
    totalUpTime: totalUpTimeResponse.data,
    activeUsers: activeUsersResponse.data,
    countActivePos: countActivePosBetweenDatesResponse.data
  });
};

export {
  fetchControllersNumber,
  fetchTotalUpTime,
  fetchActiveUsers,
  refreshDashboard,
};
